import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Product } from "@components/product/ProductTypes";
import Tools from "@ts/Tools";
import { Emitter } from "strict-event-emitter";

export default class PlanUnitCount extends ComponentBase {
  static generate(data: Product.UnitData) {
    return new PlanUnitCount(this.$sample.clone()[0] as ComponentElem, data);;
  }

  data: Product.UnitData;
  price: number;
  count: number = 0;
  isMinLimited: boolean = true;
  isMaxLimited: boolean = false;
  emitter: Emitter<{ click: [type: "add" | "reduce"] }>;

  constructor(elem: ComponentElem, data: Product.UnitData) {
    super(elem);
    this.data = data;
    this.emitter = new Emitter();
    this.$root.find(".count-title").text(data.name);

    ///@ts-ignore
    this.price = data.promote_price ? parseInt(data.promote_price) : parseInt(data.price);
    this.$root.find(".price").text(Tools.formatNumber(this.price));
    this.$root.find(".btn-reduce").on("click", (event: Event) => {
      event.preventDefault();
      if (this.isMinLimited)
        return;
      this.emitter.emit("click", "reduce");
    });

    this.$root.find(".btn-add").on("click", (event: Event) => {
      event.preventDefault();
      if (this.isMaxLimited)
        return;
      this.emitter.emit("click", "add");
    });
  }

  getData() {
    return this.data;
  }

  getCount() {
    return this.count;
  }

  getSum() {
    return this.count * this.price;
  }

  setDisabled(b: boolean) {
    b ? this.$root[0].setAttribute("disabled", "true") : this.$root[0].removeAttribute("disabled");
  }

  setUIHidden(b: boolean) {
    this.$root[0].setAttribute("is-ui-hidden", b ? "true" : "false");
  }

  setCount(newValue: number) {
    this.count = newValue;
    this.isMinLimited = newValue <= 0;
    this.$root.find(".count").text(newValue);
    this.$root.find(".btn-reduce")[0].setAttribute("disabled", this.isMinLimited ? "true" : "false");
  }

  setIsMaxLimited(b: boolean) {
    this.isMaxLimited = b;
    this.$root.find(".btn-add")[0].setAttribute("disabled", this.isMaxLimited ? "true" : "false");
  }
}